import PropTypes from 'prop-types'
import { Fragment, useMemo } from 'react'

import { Layout, Text } from '@loadsmart/miranda-react'
import { getToken } from '@loadsmart/miranda-react/dist/tokens'

import { useConfigContext } from 'config/ui/ConfigContext'
import { AdvertisingBanner } from 'loads/ui/offer-card/offer-card-banner/AdvertisingBanner'

import { CONTEXTS, OfferCard } from '../../OfferCard/OfferCard'

function OfferList(props) {
  const { date, loadOffers, onCardRedirect } = props

  const configs = useConfigContext()
  const showPTL = configs.showPTL.toBoolean()
  const bannerConfig = configs.advertisingBannerConfig.toObject()

  const loadOffersCards = useMemo(() => {
    return loadOffers.map(loadOffer => {
      const banner = bannerConfig[loadOffer.position] || null
      return (
        <Fragment key={`offer-${loadOffer.position}`}>
          {banner?.display && <AdvertisingBanner {...banner} />}
          <OfferCard
            key={loadOffer.load.uuid}
            loadOffer={loadOffer}
            onCardRedirect={onCardRedirect}
            context={CONTEXTS.LOAD_BOARD}
            showPTL={showPTL}
          />
        </Fragment>
      )
    })
  }, [loadOffers, onCardRedirect, showPTL, bannerConfig])

  return (
    <Layout.Stack style={{ paddingTop: getToken('spacing-8') }}>
      <Text variant="heading-sm-bold">{date}</Text>
      {loadOffersCards}
    </Layout.Stack>
  )
}

OfferList.propTypes = {
  loadOffers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  date: PropTypes.string.isRequired,
  separatorTopOffset: PropTypes.number,
  onCardRedirect: PropTypes.func.isRequired,
}

OfferList.defaultProps = {
  separatorTopOffset: 0,
}

export { OfferList }
